export const SET_CHAT = 'SET_CHAT'

export const UPDATE_CHAT = 'UPDATE_CHAT'

export const ADD_ATTACHMENT = 'ADD_ATTACHMENT'

export const REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT'

export const CLEAR_ATTACHMENTS = 'CLEAR_ATTACHMENTS'

export const START_TYPING = 'START_TYPING'

export const STOP_TYPING = 'STOP_TYPING'

export const SCROLL_BOTTOM = 'SCROLL_BOTTOM'

export const NEW_CONVERSATION = 'NEW_CONVERSATION'

export const SET_READING_MESSAGES = 'SET_READING_MESSAGES'

export const CREATE_MESSAGE = 'CREATE_MESSAGE'

export const SET_MESSAGE_SENDING = 'SET_MESSAGE_SENDING'

export const SET_MESSAGE_SENDED = 'SET_MESSAGE_SENDED'

export const SET_MESSAGE_ERROR = 'SET_MESSAGE_ERROR'

export const SET_MESSAGES = 'SET_MESSAGES'

export const SHOW_CLOSING_CHAT_LOADER = 'SHOW_CLOSING_CHAT_LOADER'

export const SET_CREATING_CHAT = 'SET_CREATING_CHAT'

export const FOCUS_MESSAGE = 'FOCUS_MESSAGE'

export const CLEAR_FOCUS_MESSAGE = 'CLEAR_FOCUS_MESSAGE'

export const SET_EMOJI_PAGE_STATUS = 'SET_EMOJI_PAGE_STATUS'

export const QUOTE_MESSAGE = 'QUOTE_MESSAGE'

export const CANCEL_QUOTE_MESSAGE = 'CANCEL_QUOTE_MESSAGE'

export const SET_SHOW_KB_CARD = 'SET_SHOW_KB_CARD'

export const UPDATE_COMMENT = 'UPDATE_COMMENT'

export const UPDATE_COMMENT_ERROR_MAX_LENGTH = 'UPDATE_COMMENT_ERROR_MAX_LENGTH'

export const SET_VOICE_RECORDING = 'SET_VOICE_RECORDING'

export const SET_FILE_DRAGGING = 'SET_FILE_DRAGGING'

export const TOGGLE_NUMBER_INPUT = 'TOGGLE_NUMBER_INPUT'

export const SHOW_NUMBER_INPUT = 'SHOW_NUMBER_INPUT'

export const SET_NUMBER_INPUT_VALID = 'SET_NUMBER_INPUT_VALID'

export const TOGGLE_DATE_PICKER = 'TOGGLE_DATE_PICKER'

export const SHOW_DATE_PICKER = 'SHOW_DATE_PICKER'

export const TOOGLE_DATE_PICKER_VALID = 'TOOGLE_DATE_PICKER_VALID'

export const SET_UPLOAD_IN_PROCESS = 'SET_UPLOAD_IN_PROCESS'

export const SET_TOKEN = 'SET_TOKEN'
